import { Injectable } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { SuccessComponent } from '../shared/modals/success/success.component';
import { ErrorComponent } from '../shared/modals/error/error.component';
import { ResponseComponent } from '../shared/modals/response/response.component';
import { LoadingSpinnerComponent } from '../shared/modals/loading-spinner/loading-spinner.component';
import { UpdateApplicationStatusComponent } from '../shared/modals/update-application-status/update-application-status.component';
import { UpdatePreenlistmentStatusComponent } from '../shared/modals/update-preenlistment-status/update-preenlistment-status.component';
import { StudentFilterComponent } from '../shared/modals/student-filter/student-filter.component';
import { AssignStudentScheduleConfirmComponent } from '../shared/modals/assign-student-schedule-confirm/assign-student-schedule-confirm.component';
import { SelectionModalComponent } from '../shared/modals/selection-modal/selection-modal.component';
import { CreateScheduleDetailsConfirmComponent } from '../shared/modals/create-schedule-details-confirm/create-schedule-details-confirm.component';
import { CreateEmployeeComponent } from '../shared/modals/create-employee/create-employee.component';
// import { AddVestComponent } from '../shared/modals/add-vest/add-vest.component';
import { AddGradesComponent } from '../shared/modals/add-grades/add-grades.component';
import { AddGradeComponent } from '../shared/modals/add-grade/add-grade.component';
import { UpdateEmployeeComponent } from '../shared/modals/update-employee/update-employee.component';

@Injectable({
  providedIn: 'root',
})
export class ModalService {
  modalRefSucess!: BsModalRef;
  modalRefError!: BsModalRef;
  modalRefResponse!: BsModalRef;
  modalRefLoadingSpinner!: BsModalRef;
  modalRefUpdateApplicationStatus!: BsModalRef;
  modalRefUpdatePreEnlistmentStatus!: BsModalRef;
  modalRefStudentFilter!: BsModalRef;
  modalRefAssignStudentScheduleConfirm!: BsModalRef;
  modalRefSelection!: BsModalRef;
  modalRefCreateScheduleDetailsConfirm!: BsModalRef;
  modalRefCreateEmployee: BsModalRef;
  modalRefAddGrades!: BsModalRef;
  modalRefAddGrade!: BsModalRef;

  constructor(private modalService: BsModalService) {}

  successModal(message: any) {
    const initialState = {
      message,
    };
    const config: any = {
      initialState,
      backdrop: true,
      ignoreBackdropClick: true,
      class: 'modal-dialog-centered success-modal',
    };

    return (this.modalRefSucess = this.modalService.show(
      SuccessComponent,
      config
    ));
  }

  hideSuccessModal() {
    if (this.modalRefSucess) {
      this.modalRefSucess.hide();
    }
  }

  errorModal(message: any) {
    const initialState = {
      message,
    };
    const config: any = {
      initialState,
      backdrop: true,
      ignoreBackdropClick: true,
      class: 'modal modal-dialog-centered success-modal',
    };

    return (this.modalRefError = this.modalService.show(
      ErrorComponent,
      config
    ));
  }

  hideErrorModal() {
    if (this.modalRefError) {
      this.modalRefError.hide();
    }
  }

  openResponseModal(message: any) {
    const initialState = {
      message,
    };
    const config: any = {
      initialState,
      backdrop: true,
      ignoreBackdropClick: true,
      class: 'modal-dialog-centered response-modal',
    };

    return (this.modalRefSucess = this.modalService.show(
      ResponseComponent,
      config
    ));
  }

  hideResponseModal() {
    if (this.modalRefSucess) {
      this.modalRefSucess.hide();
    }
  }

  showLoadingSpinner() {
    const config: any = {
      backdrop: true,
      ignoreBackdropClick: true,
      keyboard: false,
      class: 'modal-dialog-centered loading-spinner',
    };

    return (this.modalRefLoadingSpinner = this.modalService.show(
      LoadingSpinnerComponent,
      config
    ));
  }

  hideLoadingSpinner() {
    if (this.modalRefLoadingSpinner) {
      this.modalRefLoadingSpinner.hide();
    }
  }

  showUpdateApplicationStatus(application, schoolYearId) {
    const initialState = {
      application,
      schoolYearId,
    };
    const config: any = {
      backdrop: true,
      initialState,
      ignoreBackdropClick: true,
      keyboard: false,
      class: 'modal-dialog-centered update-application-status-modal',
    };

    return (this.modalRefUpdateApplicationStatus = this.modalService.show(
      UpdateApplicationStatusComponent,
      config
    ));
  }

  hideUpdateApplicationStatus() {
    if (this.modalRefUpdateApplicationStatus) {
      this.modalRefUpdateApplicationStatus.hide();
    }
  }

  showUpdatePreEnlistmentStatus(preEnlistment, schoolYearId) {
    const initialState = {
      preEnlistment,
      schoolYearId,
    };
    const config: any = {
      backdrop: true,
      initialState,
      ignoreBackdropClick: true,
      keyboard: false,
      class: 'modal-dialog-centered update-application-status-modal',
    };

    return (this.modalRefUpdatePreEnlistmentStatus = this.modalService.show(
      UpdatePreenlistmentStatusComponent,
      config
    ));
  }

  hideUpdatePreEnlistmentStatus() {
    if (this.modalRefUpdatePreEnlistmentStatus) {
      this.modalRefUpdatePreEnlistmentStatus.hide();
    }
  }

  showStudentFilter(tranType) {
    const initialState = {
      tranType,
    };
    const config: any = {
      initialState,
      backdrop: true,
      ignoreBackdropClick: true,
      keyboard: false,
      class: 'modal-dialog-centered student-filter-modal',
    };

    return (this.modalRefStudentFilter = this.modalService.show(
      StudentFilterComponent,
      config
    ));
  }

  hideStudentFilter() {
    if (this.modalRefStudentFilter) {
      this.modalRefStudentFilter.hide();
    }
  }

  showAssignStudentScheduleConfirm(data) {
    const initialState = {
      data,
    };
    const config: any = {
      backdrop: true,
      initialState,
      ignoreBackdropClick: true,
      keyboard: false,
      class: 'modal-dialog-centered success-modal',
    };

    return (this.modalRefAssignStudentScheduleConfirm = this.modalService.show(
      AssignStudentScheduleConfirmComponent,
      config
    ));
  }

  hideAssignStudentScheduleConfirm() {
    if (this.modalRefAssignStudentScheduleConfirm) {
      this.modalRefAssignStudentScheduleConfirm.hide();
    }
  }

  showSelectionModal(data) {
    const initialState = {
      data,
    };
    const config: any = {
      backdrop: true,
      initialState,
      ignoreBackdropClick: true,
      keyboard: true,
      class: 'modal modal-dialog-centered selection-modal-style',
    };

    return (this.modalRefSelection = this.modalService.show(
      SelectionModalComponent,
      config
    ));
  }

  hideSelectionModal() {
    if (this.modalRefSelection) {
      this.modalRefSelection.hide();
    }
  }

  showCreateScheduleDetailsConfirm(data, type) {
    const initialState = {
      data,
      type,
    };
    const config: any = {
      backdrop: true,
      initialState,
      ignoreBackdropClick: true,
      keyboard: true,
      class: 'modal modal-dialog-centered create-schedule-details',
    };

    return (this.modalRefCreateScheduleDetailsConfirm = this.modalService.show(
      CreateScheduleDetailsConfirmComponent,
      config
    ));
  }

  hideCreateScheduleDetailsConfirm() {
    if (this.modalRefCreateScheduleDetailsConfirm) {
      this.modalRefCreateScheduleDetailsConfirm.hide();
    }
  }

  showCreateEmployee() {
    const config: any = {
      backdrop: true,
      ignoreBackdropClick: true,
      keyboard: true,
      class: 'modal modal-dialog-centered create-employee custom-width',
    };

    return (this.modalRefCreateEmployee = this.modalService.show(
      CreateEmployeeComponent,
      config
    ));
  }

  showUpdateEmployee() {
    const config: any = {
      backdrop: true,
      ignoreBackdropClick: true,
      keyboard: true,
      class: 'modal modal-dialog-centered create-employee custom-width',
    };

    return (this.modalRefCreateEmployee = this.modalService.show(
      UpdateEmployeeComponent,
      config
    ));
  }

  hideCreateEmployee() {
    if (this.modalRefCreateEmployee) {
      this.modalRefCreateEmployee.hide();
    }
  }

  //Add Grades
  showAddGradesModal(data: any) {
    const initialState = {
      data,
    };
    const config: any = {
      initialState,
      backdrop: true,
      ignoreBackdropClick: true,
      keyboard: false,
      class: 'modal-dialog-centered add-grades-modal',
    };

    this.modalRefAddGrades = this.modalService.show(AddGradesComponent, config);
    return this.modalRefAddGrades.content.onClose;
  }

  hideAddGradesModal() {
    if (this.modalRefAddGrades) {
      this.modalRefAddGrades.hide();
    }
  }

  showAddGradeModal(data: any) {
    const initialState = {
      data,
    };
    const config: any = {
      initialState,
      backdrop: true,
      ignoreBackdropClick: true,
      keyboard: false,
      class: 'modal-dialog-centered add-grade-modal',
    };

    this.modalRefAddGrade = this.modalService.show(AddGradeComponent, config);
    return this.modalRefAddGrade.content.onClose;
  }

  hideAddGradeModal() {
    if (this.modalRefAddGrade) {
      this.modalRefAddGrade.hide();
    }
  }
}
